import { useEffect, useState, useContext } from 'react';
import { string } from 'prop-types';

import { i18nContext } from 'context/i18n';

import { padNumber } from 'utils/helpers';

import styles from './style.module.css';

export default function CountdownTimer({ countdown }) {
  const { t } = useContext(i18nContext);
  const [countDownObject, setCountDownObject] = useState(null);

  const calculateTime = () => {
    const countDownDate = new Date(countdown).getTime();
    const now = new Date().getTime();
    const timeLeft = countDownDate - now;

    if (timeLeft < 0) {
      setCountDownObject({ days: '00', hours: '00', minutes: '00' });
      clearInterval(this);
    } else {
      // Calculating the days, hours and minutes left
      const days = padNumber(Math.floor(timeLeft / (1000 * 60 * 60 * 24)), 2);
      const hours = padNumber(Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), 2);
      const minutes = padNumber(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)), 2);

      setCountDownObject({ days, hours, minutes });
    }
  };

  useEffect(() => {
    if (process.browser) {
      calculateTime(); // init

      setInterval(calculateTime, 60 * 1000);
    }
  }, []);

  return countDownObject === null ? null : (
      <div className={styles.countdownWrapper}>
        <div>
          <span className={styles.countdownValue}>{countDownObject.days}</span>
          <span className={styles.countdownName}>{t('landings', 'countdown.day', '***Day')}</span>
        </div>
        <div>
          <span className={styles.countdownValue}>{countDownObject.hours}</span>
          <span className={styles.countdownName}>{t('landings', 'countdown.hour', '***Hour')}</span>
        </div>
        <div>
          <span className={styles.countdownValue}>{countDownObject.minutes}</span>
          <span className={styles.countdownName}>{t('landings', 'countdown.min', '***Min')}</span>
        </div>
      </div>
    );
}

CountdownTimer.propTypes = {
  countdown: string,
};
